import {
  SHStack,
  SHToggleButtonOptions,
  SHTypography,
} from "@components/design-systems";
import { Box, Fade } from "@mui/material";
import { MaximumProductInAppendixTable } from "@pages/platform-analysis-v2/_id/constants";
import { isNil } from "lodash";

export const AppendixBusinessMetricAnalysisSectionTitle = ({
  index = 0,
  showAppendixBusinessMetricAnalysis = true,
  total,
  disabled,
  onChange,
}: {
  total: number;
  index?: number;
  showAppendixBusinessMetricAnalysis?: boolean;
  disabled?: boolean;
  onChange?: (isShow: boolean) => void;
}) => {
  const maximumProductInTable = MaximumProductInAppendixTable;

  return (
    <>
      <SHStack flexDirection={"row"} gap={"5px"}>
        <SHTypography variant="subtitle2">
          Business metric review{" "}
          <Box component="span" fontWeight={400}>
            of platforms that made it to business review stage but were not
            selected{" "}
          </Box>
          <Fade
            in
            timeout={500}
            key={showAppendixBusinessMetricAnalysis ? "appendix" : "total"}
          >
            <Box component="span" fontWeight={400}>
              {showAppendixBusinessMetricAnalysis ? (
                <>
                  (Platform {index * maximumProductInTable + 1}-
                  {Math.min(
                    index * maximumProductInTable + maximumProductInTable,
                    total,
                  )}{" "}
                  of {total})
                </>
              ) : (
                <>
                  (Total {total} platform{total > 1 && "s"})
                </>
              )}
            </Box>
          </Fade>
        </SHTypography>
      </SHStack>
      {!index && (
        <SHToggleButtonOptions
          disabled={disabled}
          options={[
            {
              label: "Show",
              value: "true",
            },
            {
              label: "Hide",
              value: "false",
            },
          ]}
          value={showAppendixBusinessMetricAnalysis.toString()}
          onChange={(_, value: string) => {
            if (onChange && !isNil(value)) onChange(value === "true");
          }}
        />
      )}
    </>
  );
};
